import { createTheme, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getLocalData } from 'utils/localDataStore';
import _merge from 'lodash/merge';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import buildTheme, { applyFontOverrides } from 'utils/theme';
import getDialogOverrides from 'themes/Dialog';
import { makeSelectClientDetails } from 'containers/Main/selectors';

const useClientTheme = () => {
  const defaultTheme = useTheme();
  const brand = getLocalData('brand')?.toLowerCase();
  const clientDetails = useSelector(makeSelectClientDetails());
  const dialogOverrides = getDialogOverrides(brand);

  // Check if client has custom fonts
  const hasCustomFont = !_isEmpty(
    _get(clientDetails, 'customFontsCollection.items', []),
  );

  // Start with base theme (either default or with custom fonts)
  let baseTheme = defaultTheme;

  if (hasCustomFont) {
    // Build theme with custom fonts if available
    baseTheme = buildTheme(
      _get(clientDetails, 'context.customHomeHeaderFont'),
      _get(clientDetails, 'context.customHomeBodyFont'),
      _get(clientDetails, 'context.customHomeHeroHeaderFont'),
    );
  }

  // Merge BlueCross BlueShield theme configuration with base theme
  const mergedTheme = _merge({}, baseTheme, dialogOverrides);

  const finalTheme = hasCustomFont
    ? applyFontOverrides(
        mergedTheme,
        _get(clientDetails, 'context.customHomeHeaderFont'),
        _get(clientDetails, 'context.customHomeBodyFont'),
        _get(clientDetails, 'context.customHomeHeroHeaderFont'),
      )
    : mergedTheme;

  return createTheme(finalTheme);
};

export default useClientTheme;
